import app from '@/main'

function errorHandler(e) {
	let data = 'Something went wrong while processing this request';
	if (e.response && e.response.status === 400) {
		data = e.response.data
	} else if (e.response && e.response.status === 401) {
		data = "You're are not logged in"
		// localStorage.clear()
		// if(app.$router.path != "/login"){
			if (document.location.pathname != '/login') {
				app.$router.replace({
					path: `/login?next=${document.location.pathname}`
				})
			}
		// }

	} else if (e.response && e.response.status === 403) {
		data = e.response.data
	} else if (e.response && e.response.status === 404) {
		data = 'Oops! an error occured '
	} else if (e.response && e.response.status === 500) {
		data = 'Oops! an error occured'
	} else if (e.response && e.response.status === 406) {
		data = e.response.data;
	}
	else if (e.response && e.response.status === 422) {
		data = e.response.data;
	} else if (!e.response) {
		data = "Please check your internent connection"
	}
	const status = e.response ? e.response.status : 0
	return {
		status,
		data
	}
}

export { errorHandler }